// src/components/RecentAttendanceList.js

import React from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Typography,
} from "@mui/material";
import { styled } from "@mui/material/styles";

// Sample static data for recent attendance records
// const recentRecords = [
//   { id: 1, name: "John Doe", date: "2024-04-25", status: "Present" },
//   { id: 2, name: "Jane Smith", date: "2024-04-25", status: "Absent" },
//   { id: 3, name: "Alice Johnson", date: "2024-04-24", status: "Present" },
//   { id: 4, name: "Bob Brown", date: "2024-04-24", status: "Present" },
//   { id: 5, name: "Charlie Davis", date: "2024-04-23", status: "Absent" },
// ];

// Styled component for the table header
const StyledTableCell = styled(TableCell)(({ theme }) => ({
  backgroundColor: theme.palette.primary.light,
  color: theme.palette.common.white,
  fontWeight: "bold",
}));

const RecentAttendanceList = ({ recentList }) => {

  const date = new Date();
  const formattedDate = date.toLocaleDateString("en-US", {
    month: "2-digit",
    day: "2-digit",
    year: "numeric",
  });

  return (
    <TableContainer component={Paper}>
      <Table aria-label="recent attendance table">
        <TableHead>
          <TableRow>
            {/* <StyledTableCell>ID</StyledTableCell> */}
            <StyledTableCell>Name</StyledTableCell>
            <StyledTableCell>Date</StyledTableCell>
            <StyledTableCell>Status</StyledTableCell>
          </TableRow>
        </TableHead>
        <TableBody>
        {recentList?.attendance
  .filter((attendanceEntry) => {
    // Format attendanceEntry.date to 'MM/DD/YYYY' format
    const entryDate = new Date(attendanceEntry.date).toLocaleDateString("en-US", {
      month: "2-digit",
      day: "2-digit",
      year: "numeric"
    });
    return entryDate === formattedDate;
  })
  .map((attendanceEntry) =>
    attendanceEntry?.records?.map((row) => (
      <TableRow key={row?._id}>
        {/* <TableCell>{row?.studentId}</TableCell> */}
        <TableCell>{row?.name}</TableCell>
        <TableCell>{attendanceEntry.date}</TableCell>
        <TableCell>
          <Typography
            variant="body2"
            color={row?.status === 'Present' ? 'green' : 'red'}
          >
            {row?.status}
          </Typography>
        </TableCell>
      </TableRow>
    ))
  )}

        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default RecentAttendanceList;
